/*
  Dandelion, listicle Bébé : script unique de la page (chargé en defer par snippets/dl-listicle-base.liquid).
  Core : tracking, défilement doux, événements « vus » une seule fois, accordéons, apparitions, compteur panier.
  Aucune dépendance. Tous les écouteurs sont délégués ; aucun code n'est requis dans les sections,
  sauf les modules qui passent par la file window.dlQ (voir en bas).

  API publique
  - window.dlTrack(name, params, once)  -> dataLayer + Shopify.analytics.publish + clarity (si présents)
  - window.dlListicle = { track, scroll, scan, money, refreshCart, setCartCount, root, reduced }
  - window.dlQ.push(function (dl) { ... })  -> exécuté à l'initialisation (ou tout de suite si déjà prête)
  Attributs
  - [data-dl-scroll="#cible"]              défilement doux + focus de la cible
  - [data-dl-track="evt"] [data-dl-track-params='{"k":"v"}']   suivi au clic
  - [data-dl-seen="evt"] [data-dl-track-params='{...}']        suivi une fois, visible à 35 %
  - button[data-dl-acc][aria-controls][aria-expanded]           accordéon (suivi à l'ouverture seulement)
  - video[data-dl-video][data-src]                              vidéo muette en boucle : source posée à l'approche,
                                                                lecture seulement à l'écran (aucune si mouvement réduit)
  Événements DOM
  - écoute « dl:cart-updated » (detail.item_count ou detail.cart facultatifs) -> met à jour .dl-top__count
  - émet « dl:acc-toggle » (detail.open) sur le bouton d'accordéon
*/
(function () {
  'use strict';
  var w = window;
  var d = document;
  var de = d.documentElement;
  if (w.__dlCore) return;
  w.__dlCore = 1;

  var hasIO = 'IntersectionObserver' in w;
  var reduced = false;
  try { reduced = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}
  var debug = false;
  try { debug = !!w.__dlDebug || /[?&]dl_debug=1(&|$)/.test(w.location.search); } catch (e) {}

  function each(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i], i); }
  function log() { if (debug && w.console) { try { w.console.info.apply(w.console, ['[dl]'].concat([].slice.call(arguments))); } catch (e) {} } }
  function rootUrl() {
    try { if (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) return w.Shopify.routes.root; } catch (e) {}
    return '/';
  }

  /* ---------- Tracking ---------- */
  var onceReg = w.__dlOnce = w.__dlOnce || {};
  function track(name, params, once) {
    if (!name || typeof name !== 'string') return false;
    if (once) {
      if (onceReg[name]) return false;
      onceReg[name] = 1;
    }
    var p = {};
    if (params && typeof params === 'object') {
      for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
    }
    var layer = {};
    for (var j in p) layer[j] = p[j];
    layer.event = name;
    try { w.dataLayer = w.dataLayer || []; w.dataLayer.push(layer); } catch (e) {}
    try {
      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') {
        w.Shopify.analytics.publish(name, p);
      }
    } catch (e) {}
    try { if (typeof w.clarity === 'function') w.clarity('event', name); } catch (e) {}
    log(name, p);
    return true;
  }
  function paramsOf(el) {
    var raw = el && el.getAttribute('data-dl-track-params');
    if (!raw) return {};
    try {
      var o = JSON.parse(raw);
      return o && typeof o === 'object' ? o : {};
    } catch (e) { return {}; }
  }

  /* ---------- Défilement doux ---------- */
  var FOCUSABLE = /^(A|BUTTON|INPUT|SELECT|TEXTAREA|SUMMARY)$/;
  function findTarget(sel) {
    if (!sel || typeof sel !== 'string') return null;
    try { return d.querySelector(sel); } catch (e) {}
    try { return d.getElementById(sel.replace(/^#/, '')); } catch (e) {}
    return null;
  }
  function scrollToTarget(target) {
    var el = typeof target === 'string' ? findTarget(target) : target;
    if (!el || !el.scrollIntoView) return false;
    try { el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); } catch (e) { el.scrollIntoView(true); }
    if (!FOCUSABLE.test(el.tagName) && !el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    // Focus différé : ne casse pas l'animation sur les navigateurs sans preventScroll.
    w.setTimeout(function () {
      try { el.focus({ preventScroll: true }); } catch (e) {}
    }, reduced ? 0 : 450);
    return true;
  }

  /* ---------- Accordéons ---------- */
  function panelOf(btn) {
    var ids = (btn.getAttribute('aria-controls') || '').split(/\s+/);
    return ids[0] ? d.getElementById(ids[0]) : null;
  }
  function setupAcc(btn) {
    if (btn.__dlAcc) return;
    btn.__dlAcc = 1;
    var panel = panelOf(btn);
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    if (!btn.hasAttribute('aria-expanded')) btn.setAttribute('aria-expanded', 'false');
    panel.hidden = !open;
  }
  function toggleAcc(btn, force) {
    var panel = panelOf(btn);
    if (!panel) return;
    var open = typeof force === 'boolean' ? force : btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    if (open) {
      var name = btn.getAttribute('data-dl-track');
      if (name) track(name, paramsOf(btn));
    }
    try { btn.dispatchEvent(new CustomEvent('dl:acc-toggle', { bubbles: true, detail: { open: open } })); } catch (e) {}
  }

  /* ---------- Clics délégués ---------- */
  d.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.nodeType !== 1) t = t.parentElement;
    if (!t || !t.closest) return;

    var acc = t.closest('[data-dl-acc]');
    if (acc) {
      ev.preventDefault();
      toggleAcc(acc);
      return;
    }
    var tr = t.closest('[data-dl-track]');
    if (tr) track(tr.getAttribute('data-dl-track'), paramsOf(tr));

    var sc = t.closest('[data-dl-scroll]');
    if (sc) {
      if (ev.defaultPrevented || ev.button > 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
      if (scrollToTarget(sc.getAttribute('data-dl-scroll'))) ev.preventDefault();
    }
  }, false);

  /* ---------- Vu une fois (≥ 35 % de l'élément, ou 35 % de l'écran pour les blocs très hauts) ---------- */
  var seenIO = hasIO ? new IntersectionObserver(function (entries) {
    var vh = w.innerHeight || de.clientHeight || 1;
    each(entries, function (e) {
      if (!e.isIntersecting) return;
      if (e.intersectionRatio >= 0.35 || e.intersectionRect.height >= vh * 0.35) {
        seenIO.unobserve(e.target);
        track(e.target.getAttribute('data-dl-seen'), paramsOf(e.target), true);
      }
    });
  }, { threshold: [0, 0.1, 0.2, 0.35, 0.5, 0.75, 1] }) : null;

  /* ---------- Apparitions (.dl-rv) ---------- */
  var rvIO = hasIO && !reduced ? new IntersectionObserver(function (entries) {
    each(entries, function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); rvIO.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0 }) : null;
  function inViewport(el) {
    var r = el.getBoundingClientRect();
    var vh = w.innerHeight || de.clientHeight;
    return r.bottom > 0 && r.top < vh;
  }

  /* ---------- Vidéos en boucle (video[data-dl-video][data-src]) ----------
     Source posée environ un écran avant (préchargement), lecture quand 20 % sont visibles, pause dès la sortie.
     Mouvement réduit : pas de lecture automatique, commandes natives. Sans JS : l'aperçu (poster) reste. */
  function loadVideo(v) {
    if (v.__dlSrc) return;
    var src = v.getAttribute('data-src');
    if (!src) return;
    v.__dlSrc = 1;
    if (!reduced) v.preload = 'auto';
    v.src = src;
  }
  function playVideo(v) {
    if (reduced) return;
    v.muted = true;
    try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {}
  }
  var vidNearIO = hasIO ? new IntersectionObserver(function (entries) {
    each(entries, function (e) {
      if (e.isIntersecting) { vidNearIO.unobserve(e.target); loadVideo(e.target); }
    });
  }, { rootMargin: '100% 0px 100% 0px' }) : null;
  var vidPlayIO = hasIO && !reduced ? new IntersectionObserver(function (entries) {
    each(entries, function (e) {
      if (e.isIntersecting) { loadVideo(e.target); playVideo(e.target); }
      else if (!e.target.paused) e.target.pause();
    });
  }, { threshold: 0.2 }) : null;
  function setupVideo(v) {
    if (v.__dlVid) return;
    v.__dlVid = 1;
    if (reduced) v.controls = true;
    if (!hasIO) { loadVideo(v); playVideo(v); return; }
    vidNearIO.observe(v);
    if (vidPlayIO) vidPlayIO.observe(v);
  }

  /* Initialise (ou réinitialise) un sous-arbre : utile pour du contenu injecté plus tard. */
  function scan(root) {
    root = root && root.querySelectorAll ? root : d;
    each(root.querySelectorAll('[data-dl-acc]'), setupAcc);
    each(root.querySelectorAll('video[data-dl-video]'), setupVideo);
    each(root.querySelectorAll('.dl-rv:not(.is-in)'), function (el) {
      if (!rvIO || inViewport(el)) el.classList.add('is-in');
      else rvIO.observe(el);
    });
    each(root.querySelectorAll('[data-dl-seen]'), function (el) {
      if (el.__dlSeen) return;
      el.__dlSeen = 1;
      if (seenIO) seenIO.observe(el);
    });
  }

  /* ---------- Compteur panier (.dl-top__count) ---------- */
  function setCartCount(n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 0) return;
    each(d.querySelectorAll('.dl-top__count'), function (el) {
      el.textContent = String(n);
      el.setAttribute('data-count', String(n));
      el.hidden = n < 1;
    });
  }
  var countTimer = 0;
  var countSeq = 0;
  function refreshCart() {
    if (!w.fetch) return;
    w.clearTimeout(countTimer);
    countTimer = w.setTimeout(function () {
      var seq = ++countSeq;
      w.fetch(rootUrl() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && seq === countSeq) setCartCount(c.item_count); })
        .catch(function () {});
    }, 60);
  }
  function countFrom(detail) {
    if (!detail || typeof detail !== 'object') return null;
    if (typeof detail.item_count === 'number') return detail.item_count;
    if (detail.cart && typeof detail.cart.item_count === 'number') return detail.cart.item_count;
    return null;
  }
  d.addEventListener('dl:cart-updated', function (ev) {
    var n = countFrom(ev && ev.detail);
    if (n === null) refreshCart(); else setCartCount(n);
  });
  w.addEventListener('pageshow', function (ev) { if (ev.persisted) refreshCart(); });

  /* ---------- Prix « 39 CHF » / « 39,50 CHF » à partir de centimes ---------- */
  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var s = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2).replace('.', ',');
    return s + ' CHF';
  }

  /* ---------- API ---------- */
  var api = {
    track: track,
    scroll: scrollToTarget,
    scan: scan,
    money: money,
    refreshCart: refreshCart,
    setCartCount: setCartCount,
    root: rootUrl,
    reduced: reduced
  };
  w.dlTrack = track;
  w.dlListicle = api;

  function run(fn) {
    if (typeof fn !== 'function') return;
    try { fn(api); } catch (e) { log('module', e); }
  }

  function init() {
    // Les éléments déjà à l'écran sont marqués visibles AVANT d'activer html.dl-js : aucun clignotement.
    try { scan(d); } catch (e) { log('scan', e); }
    de.classList.add('dl-js');

    // Panier modifié depuis le tiroir Dawn (quantités) : pubsub du thème, s'il est présent.
    try {
      if (typeof w.subscribe === 'function') {
        /* global PUB_SUB_EVENTS */
        var evName = typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate ? PUB_SUB_EVENTS.cartUpdate : 'cart-update';
        w.subscribe(evName, function (e) {
          var n = countFrom(e && e.cartData);
          if (n === null) refreshCart(); else setCartCount(n);
        });
      }
    } catch (e) {}

    var view = '';
    try { view = decodeURIComponent((w.location.search.match(/[?&]view=([^&#]+)/) || [])[1] || ''); } catch (e) {}
    track('dl_listicle_view', { page_path: w.location.pathname, view: view }, true);

    // File de modules (buy box, sticky…) : fonctions poussées avant ou après le chargement.
    var queued = w.dlQ && typeof w.dlQ.length === 'number' ? w.dlQ : [];
    w.dlQ = { push: function () { each(arguments, run); return 0; } };
    each(queued, run);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();

  w.addEventListener('beforeprint', function () {
    each(d.querySelectorAll('.dl-rv:not(.is-in)'), function (el) { el.classList.add('is-in'); });
  });
})();
